export const HIERARCHY_STRUCTURE_API = 'hierarchy-structures';
export const HIERARCHY_STRUCTURE_DROPDOWN_API = `${HIERARCHY_STRUCTURE_API}/for-dropdown`;

export const resolveHierarchyApiName = (apiName) =>
  apiName === HIERARCHY_STRUCTURE_API ? HIERARCHY_STRUCTURE_DROPDOWN_API : apiName;
